import { useEffect, useState } from 'react'

export function useStickyCta(startId: string, endId: string) {
  const [pastStart, setPastStart] = useState(false)
  const [atEnd, setAtEnd] = useState(false)

  useEffect(() => {
    const start = document.getElementById(startId)
    const end = document.getElementById(endId)
    if (!start || !end) return

    const startObserver = new IntersectionObserver(([entry]) => {
      setPastStart(!entry.isIntersecting && entry.boundingClientRect.top < 0)
    })
    const endObserver = new IntersectionObserver(([entry]) => {
      setAtEnd(entry.isIntersecting || entry.boundingClientRect.top < 0)
    })

    startObserver.observe(start)
    endObserver.observe(end)
    return () => {
      startObserver.disconnect()
      endObserver.disconnect()
    }
  }, [startId, endId])

  return pastStart && !atEnd
}
